import type { Tournament } from '@swf/poker';

export enum SundayMillionTab {
  Main = 'main',
  Satellites = 'satellites'
}

export interface MainEventTournament extends Tournament {
  nextWhenStartInt?: number;
  resumeTimeInt?: number;
  tournNumDays?: number;
}
